import { Box } from '@mui/material'
import Loading from 'component/Loading'

/**
 * Shared inline loading state for dashboard-targets tabs.
 *
 * Each tab early-returns this while it resolves AboutUs + bucket data,
 * so the layout stays inside the tab (not a full-screen overlay) and
 * uses the system's `loading-spinner` CSS class via the `softLoading`
 * mode of the shared Loading component — so every tab looks the same
 * during its initial data fetch.
 */
export default function TabLoading() {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', py: 6 }}>
      <Loading show type="softLoading" />
    </Box>
  )
}
